import {Engine} from "@acng/frontend-stargazer";
import {t} from "acng/locale/config/translate";

angular.module('core').component('onswOverlayReason', {
  bindings: {overlay: '<'},
  transclude: 'element',
  controller: [
    '$scope',
    '$element',
    '$transclude',
    '$animate',
    '$compile',
    '$timeout',
    function ($scope, $element, $transclude, $animate, $compile, $timeout) {
      const template = `<div class="box" ng-click="$ctrl.click()">
      <span class="text">{{ $ctrl.text }}</span>
        <div onsw-item ons-icon="::close"></div>
      </div>`;
      this.$onChanges = async () => {
        if (!this.overlay?.params.reason) {
          return;
        }
        const params = this.overlay.params.reasonParams ? JSON.parse(this.overlay.params.reasonParams) : undefined;
        let text = this.overlay.params.reason;
        const [firstWord] = /\w*/.exec(text);

        if (Engine.root.template.content.getElementById(firstWord)) {
          text = await t(text, params);
        }

        this.text = text;

        $transclude(clone => {
          clone.append($compile(template)($scope));
          this.el = clone;
          this.el.addClass('overlay-toolbar');
          $animate.enter(clone, false, $element);
          $timeout(() => $animate.leave(clone), this.getHideTimeout());
        });
      };
      this.getHideTimeout = () => {
        if (this.overlay.params.reasonClasses?.includes('free-cam')) {
          return 20000;
        }
        return 8000;
      };
      this.click = () => {
        $animate.leave(this.el);
      };
    },
  ],
});
